import { ReactNode } from "react";

import PageInfo from "components/PageWrapper/Info";
import Button from "ds/components/Button";
import useTitle from "hooks/useTitle";
import { Blueprint } from "types/generated";
import Tooltip from "ds/components/Tooltip";
import useCanManageBlueprint from "shared/Blueprint/access/useCanManageBlueprint";

type BlueprintIntegrationsPageLayoutProps = {
  children: ReactNode;
  onCreate?: () => void;
  blueprint: Blueprint;
  isDraft: boolean;
};

const BlueprintIntegrationsPageLayout = ({
  children,
  onCreate,
  blueprint,
  isDraft,
}: BlueprintIntegrationsPageLayoutProps) => {
  useTitle(`Integrations · ${blueprint.name}`);

  const canManageBlueprint = useCanManageBlueprint()(blueprint);

  return (
    <>
      <PageInfo title="Integrations">
        <Tooltip
          active={isDraft || !!canManageBlueprint.message}
          on={(props) => (
            <Button
              {...props}
              onPress={onCreate}
              disabled={isDraft || !canManageBlueprint.result}
              variant="primary"
            >
              Attach integration
            </Button>
          )}
        >
          {isDraft ? "Cannot attach integration to a draft blueprint" : canManageBlueprint.message}
        </Tooltip>
      </PageInfo>
      {children}
    </>
  );
};

export default BlueprintIntegrationsPageLayout;
